/**
 * URL parsing without the Public Suffix List, so code that only compares origins (the content
 * script, injected into every page) does not carry the list. Import as
 * `@passwordflow/domains/origin`.
 */
const SCHEME_PREFIX = /^[a-z][a-z0-9+.-]*:\/\//iu;
function toOrigin(url) {
    if (url.protocol !== "http:" && url.protocol !== "https:") {
        return undefined;
    }
    if (url.hostname === "") {
        return undefined;
    }
    return { protocol: url.protocol, hostname: url.hostname.toLowerCase(), port: url.port, origin: url.origin };
}
/** Parses a page URL. Only http(s) pages are fillable; file:, data:, about:, extension pages are not. */
export function parsePageUrl(raw) {
    try {
        return toOrigin(new URL(raw));
    }
    catch {
        return undefined;
    }
}
/** Parses the URL stored on an entry. Bare hosts ("github.com") are read as https. */
export function parseEntryUrl(raw) {
    const value = raw.trim();
    if (value === "") {
        return undefined;
    }
    const candidate = SCHEME_PREFIX.test(value) ? value : `https://${value}`;
    try {
        return toOrigin(new URL(candidate));
    }
    catch {
        return undefined;
    }
}
/** Same-origin check used by the content script right before it writes into a field. */
export function sameOrigin(a, b) {
    const left = parsePageUrl(a);
    const right = parsePageUrl(b);
    return left !== undefined && right !== undefined && left.origin === right.origin;
}
//# sourceMappingURL=origin.js.map